import { render, staticRenderFns } from "./fkjlb.vue?vue&type=template&id=041be564&scoped=true"
import script from "./fkjlb.vue?vue&type=script&lang=js"
export * from "./fkjlb.vue?vue&type=script&lang=js"
import style0 from "./fkjlb.vue?vue&type=style&index=0&id=041be564&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "041be564",
  null
  
)

export default component.exports